import { ITransitionPage } from '@barba/core';
import { mapLeaveToIndex } from '@/animations/map-page-animations';
import { indexEnter } from '@/animations/index-page-animations';

export default {
    name: 'map-to-index-transition',

    from: {
        namespace: 'map-page',
    },

    to: {
        namespace: 'index-page',
    },

    enter() {
        window.scrollTo({ top: 0, behavior: 'auto' });
    },

    beforeLeave({ current }) {
        return new Promise((resolve) => {
            mapLeaveToIndex(current.container, resolve);
        });
    },

    afterEnter({ next }) {
        indexEnter(next.container);
    },
} as ITransitionPage;
